/*
 * "Avísame cuando vuelva" (back-in-stock) — lógica del cliente.
 *
 * El snippet notify-me.liquid emite solo el markup + un JSON con el stock por variante.
 * Aquí decidimos, en el cliente y en vivo, si mostrar el botón (según la variante
 * seleccionada) y enviamos la suscripción al backend propio (AWS API Gateway).
 *
 * Backend (tú): guarda {email, variantId, productId} y, vía webhook de Shopify
 * (inventory_levels/update) + Resend, avisa al cliente cuando el producto vuelve.
 *
 * Configura tu endpoint en window.TT_NOTIFY_CONFIG.endpoint (o define ese objeto
 * antes de cargar este archivo, ej. desde layout/theme.liquid con Liquid).
 */
(function () {
  window.TT_NOTIFY_CONFIG = window.TT_NOTIFY_CONFIG || {
    // Backend Shopysale (mismo host/company que el delivery-promise).
    endpoint: 'https://shopy-sale-v2.fly.dev/shopsale/v1/public/back-in-stock/6a2c74bc4a5a319f7db152bd'
  };

  if (window.__ttNotify) return;   // una sola vez por página
  window.__ttNotify = true;

  var root = document.querySelector('[data-tt-notify]');
  if (!root) return;

  // --- Mapa de stock por variante (inyectado por el snippet) ---
  var stock = {};
  try {
    var raw = document.querySelector('[data-tt-notify-stock]');
    var data = JSON.parse(raw.textContent);
    (data.variants || []).forEach(function (v) { stock[String(v.id)] = v; });
  } catch (e) { /* sin datos → el botón simplemente no aparece */ }

  var modal = root.querySelector('[data-tt-notify-modal]');
  var form = root.querySelector('[data-tt-notify-form]');
  var emailEl = root.querySelector('[data-tt-notify-email]');
  var waEl = root.querySelector('[data-tt-notify-wa]');
  var consentEl = root.querySelector('[data-tt-notify-consent]');
  var feedback = root.querySelector('[data-tt-notify-feedback]');
  var nameEl = root.querySelector('[data-tt-notify-name]');

  // --- ¿Qué variante está seleccionada ahora? ---
  function currentVariantId() {
    // 1) input/select name="id" del form de producto (fuente de verdad de Shopify)
    var idInput = document.querySelector('[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]');
    if (idInput && idInput.value) return idInput.value;
    // 2) parámetro ?variant= de la URL
    var m = location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    // 3) primera variante conocida
    var keys = Object.keys(stock);
    return keys.length ? keys[0] : null;
  }

  // --- Alternar según el stock de la variante actual ---
  // Agotado → oculta el bloque de compra (.product-form--atc) y muestra "Avísame".
  // Con stock → al revés. Cubre el estado inicial y el cambio de variante en vivo.
  function refresh() {
    var id = currentVariantId();
    var v = id ? stock[String(id)] : null;
    var soldOut = !!(v && v.available === false);
    document.querySelectorAll('.product-form--atc').forEach(function (atc) {
      atc.style.display = soldOut ? 'none' : '';
    });
    document.querySelectorAll('[data-tt-notify-open]').forEach(function (btn) {
      btn.hidden = !soldOut;
    });
    if (soldOut && nameEl) nameEl.textContent = root.dataset.productTitle || 'este producto';
  }

  // --- Modal (mismo patrón que el resto del tema) ---
  function openM() {
    modal.hidden = false;
    void modal.offsetWidth;                 // reflow → siempre anima
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { if (emailEl) emailEl.focus(); }, 60);
  }
  function closeM() {
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 320);
  }

  // El botón "Avísame" vive en el formulario (puede haber más de uno) → delegación.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-tt-notify-open]')) { e.preventDefault(); openM(); }
  });
  root.querySelectorAll('[data-tt-notify-close]').forEach(function (b) { b.addEventListener('click', closeM); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeM();
  });

  // --- Envío al backend ---
  function say(msg, ok) {
    if (!feedback) return;
    feedback.hidden = false;
    feedback.textContent = msg;
    feedback.className = 'tt-notify__msg ' + (ok ? 'is-ok' : 'is-err');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (emailEl && emailEl.value || '').trim();
    var whatsapp = (waEl && waEl.value || '').trim();
    var consent = !!(consentEl && consentEl.checked);
    var emailOk = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
    var waOk = whatsapp.replace(/[^\d]/g, '').length >= 8;   // al menos 8 dígitos
    if (!emailOk && !waOk) { say('Ingresa un correo o un WhatsApp válido.', false); return; }

    var id = currentVariantId();
    var v = id ? stock[String(id)] : null;
    var submit = form.querySelector('[data-tt-notify-submit]');
    var original = submit.textContent;
    submit.disabled = true;
    submit.textContent = 'Enviando…';

    fetch(window.TT_NOTIFY_CONFIG.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        shop: root.dataset.shop,
        email: emailOk ? email : '',
        whatsapp: waOk ? whatsapp : '',
        marketingConsent: consent,
        productId: root.dataset.productId,
        productTitle: root.dataset.productTitle,
        productUrl: location.origin + root.dataset.productUrl,
        variantId: id,
        variantTitle: v ? v.title : '',
        sku: v ? v.sku : ''
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('fail'); return r.json().catch(function () { return {}; }); })
      .then(function () {
        say('¡Listo! Te avisaremos apenas vuelva. 🔔', true);
        form.reset();
        setTimeout(closeM, 1800);
      })
      .catch(function () { say('No pudimos registrar tu aviso. Inténtalo de nuevo.', false); })
      .then(function () { submit.disabled = false; submit.textContent = original; });
  });

  // --- Reaccionar al cambio de variante (dinámico) ---
  var raf = null;
  function scheduleRefresh() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = null; refresh(); });
  }

  // Cambio de variante: escuchamos los inputs del form (selector de opciones,
  // input name="id") — señal estándar de Shopify. Sin MutationObserver (evita
  // trabajo continuo mientras Empire reescribe el form).
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'id' || (e.target.closest && e.target.closest('[data-product-form]')))) scheduleRefresh();
  });
  window.addEventListener('popstate', scheduleRefresh);

  refresh();
})();
